import { loadTranslations, setLocale, I18n } from 'react-redux-i18n';
import moment from 'moment';
import { IS_LOADING, LOAD_USER_LIST, LOAD_USER, USER_LIST_NEED_RELOAD, FORM_ERROR } from './types/userTypes';
import { SHOW_MESSAGE, HIDE_MESSAGE } from './types/messageTypes';
import enLanguage from './../../i18n/en';
import pt_BRLanguage from './../../i18n/pt_BR';
import api from './../../api';

export function getList(params) {

  return (dispatch) => {

    dispatch({
      type: IS_LOADING,
      result: true,
    });

    return new Promise((resolve, reject) => {

      api.get('/api/Account', {
        params,
      }).then(
        (response) => {

          dispatch({
            type: IS_LOADING,
            result: false,
          });

          dispatch({
            type: USER_LIST_NEED_RELOAD,
            result: false,
          });

          dispatch({
            type: LOAD_USER_LIST,
            result: response.data,
          });

          resolve(response.data);

        },
        (error) => {

          dispatch({
            type: IS_LOADING,
            result: false,
          });

          reject(error.response.data);

        }
      );

    });

  };

}

export function get(id) {

  return (dispatch) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.loading_data'),
    });

    return api.get(`/api/Account/${id}`).then(
      (response) => {

        dispatch({
          type: LOAD_USER,
          result: response.data,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        return response.data;

      }
    );

  };

}

export function save(data) {

  return (dispatch) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.saving_data'),
    });

    dispatch({
      type: FORM_ERROR,
      result: [],
    });

    let request;

    if (data.id)
      request = api.put('api/Account/Update', data);
    else
      request = api.post('api/Account/Register', data);


    return new Promise((resolve, reject) => {

      request.then((response) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        resolve(response.data);

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        dispatch({
          type: FORM_ERROR,
          result: error.response.data.errors,
        });

        reject(error.response.data.errors);

      });

    });

  };

}

export function block(id) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.blocking_data'),
    });

    api.post(`api/Account/block/${id}`)
      .then(() => {

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

}

export function unblock(id) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.unblocking_data'),
    });

    api.post(`api/Account/unblock/${id}`)
      .then(() => {

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

}

export function inactivate(id) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.deleting_data'),
    });

    api.post(`api/Account/inactivate/${id}`)
      .then(() => {

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

}

export function activate(id) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.activating_data'),
    });

    api.post(`api/Account/activate/${id}`)
      .then(() => {

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

}

export function standBy(data) {

  return dispatch => new Promise((resolve, reject) => {

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.standby_data'),
    });

    api.post(`api/Account/standby/${data.id}/${moment(data.standByLimit).format('YYYY-MM-DD')}`)
      .then(() => {

        dispatch({
          type: USER_LIST_NEED_RELOAD,
          result: true,
        });

        dispatch({
          type: HIDE_MESSAGE,
        });

        resolve();

      }, (error) => {

        dispatch({
          type: HIDE_MESSAGE,
        });

        reject(error.response.data.errors);

      });

  });

}

export function changePass(data) {

  return (dispatch) => {

    dispatch({
      type: IS_LOADING,
      result: true,
    });

    dispatch({
      type: SHOW_MESSAGE,
      result: I18n.t('messages.changing_pass'),
    });

    return new Promise((resolve, reject) => {

      api.post('/api/account/reset-password', data).then(
        (response) => {

          dispatch({
            type: IS_LOADING,
            result: false,
          });

          dispatch({
            type: HIDE_MESSAGE,
          });

          resolve(response);

        },
        (error) => {

          dispatch({
            type: IS_LOADING,
            result: false,
          });

          dispatch({
            type: FORM_ERROR,
            result: error.response.data.errors,
          });

          reject(error);

        }
      );

    });

  };

}

export function getLanguage() {

  const language = localStorage.getItem('language');

  return language || 'pt_BR';

}

export function setLanguage(language = false) {

  return (dispatch) => {

    dispatch(loadTranslations({
      en: enLanguage,
      pt_BR: pt_BRLanguage,
    }));

    if (!language)
      language = getLanguage();


    dispatch(setLocale(language));
    localStorage.setItem('language', language);

  };

}



// WEBPACK FOOTER //
// ./src/redux/actions/userActions.js